// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__T9qq7","overflowing":"ReadFullNote_overflowing__2SW8P"};